/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Oauth2AuthorizationCodeAccessToken } from './Oauth2AuthorizationCodeAccessToken';
import {
    Oauth2AuthorizationCodeAccessTokenFromJSON,
    Oauth2AuthorizationCodeAccessTokenFromJSONTyped,
    Oauth2AuthorizationCodeAccessTokenToJSON,
} from './Oauth2AuthorizationCodeAccessToken';
import type { Oauth2AuthorizationCodeRefreshToken } from './Oauth2AuthorizationCodeRefreshToken';
import {
    Oauth2AuthorizationCodeRefreshTokenFromJSON,
    Oauth2AuthorizationCodeRefreshTokenFromJSONTyped,
    Oauth2AuthorizationCodeRefreshTokenToJSON,
} from './Oauth2AuthorizationCodeRefreshToken';

/**
 * 
 * @export
 * @interface Oauth2AuthorizationCode
 */
export interface Oauth2AuthorizationCode {
    /**
     * 
     * @type {Oauth2AuthorizationCodeAccessToken}
     * @memberof Oauth2AuthorizationCode
     */
    accessToken?: Oauth2AuthorizationCodeAccessToken;
    /**
     * 
     * @type {Oauth2AuthorizationCodeRefreshToken}
     * @memberof Oauth2AuthorizationCode
     */
    refreshToken?: Oauth2AuthorizationCodeRefreshToken;
    /**
     * The scopes for the tokens.
     * @type {Array<string>}
     * @memberof Oauth2AuthorizationCode
     */
    scopes?: Array<string>;
}

/**
 * Check if a given object implements the Oauth2AuthorizationCode interface.
 */
export function instanceOfOauth2AuthorizationCode(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Oauth2AuthorizationCodeFromJSON(json: any): Oauth2AuthorizationCode {
    return Oauth2AuthorizationCodeFromJSONTyped(json, false);
}

export function Oauth2AuthorizationCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Oauth2AuthorizationCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessToken': !exists(json, 'accessToken') ? undefined : Oauth2AuthorizationCodeAccessTokenFromJSON(json['accessToken']),
        'refreshToken': !exists(json, 'refreshToken') ? undefined : Oauth2AuthorizationCodeRefreshTokenFromJSON(json['refreshToken']),
        'scopes': !exists(json, 'scopes') ? undefined : json['scopes'],
    };
}

export function Oauth2AuthorizationCodeToJSON(value?: Oauth2AuthorizationCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessToken': Oauth2AuthorizationCodeAccessTokenToJSON(value.accessToken),
        'refreshToken': Oauth2AuthorizationCodeRefreshTokenToJSON(value.refreshToken),
        'scopes': value.scopes,
    };
}

